import React from 'react'
import styled from 'styled-components'

const InputStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;

  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.18);
  border-radius: 3px;

  &:focus {
    background: red;
  }

  button {
    padding: 0.7rem;
    width: 100%;
    height: 50px;
    min-width: 3rem;
    font-size: 1rem;
    font-weight: bold;
    border: 0 solid #dbdbdb;
    text-align: center;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
    cursor: pointer;

    &:hover {
      background: #ccccccff !important;
      color: #555 !important;
    }

    &.left {
      border-radius: 3px 0 0 3px;
    }

    &.right {
      border-radius: 0 3px 3px 0;
    }
  }

  input {
    width: 4rem;
    height: 50px;
    padding: 0.7rem;
    font-size: 1rem;
    border: 0;
    border-top: 0 solid #dbdbdb;
    border-bottom: 0 solid #dbdbdb;
    text-align: center;
  }
`

const QtyInput = (props) => {
  const { id, label, alternativeId, value, onInputChange, onIncrement, onDecrement, isMaxQty } = props
  return (
    <>
      {label && (
        <label className="d-flex justify-content-center">
          {label}
        </label>
      )}
      <InputStyles className="quantity-input">
        <button
          type="button"
          className="left bg-light"
          onClick={(e) => {
            e.preventDefault()
            onDecrement()
          }}
        >
          &mdash;
        </button>
        <input
          id={id}
          data-alternative-id={alternativeId}
          type="text"
          value={value}
          onChange={(e) => onInputChange(e.target.value)}
          readOnly
        />
        <button
          type="button"
          disabled={isMaxQty}
          className="right bg-light"
          onClick={(e) => {
            e.preventDefault()
            onIncrement()
          }}
        >
          ＋
        </button>
      </InputStyles>
    </>
  )
}

export default QtyInput